const Experiences = [
    {
        name: 'Aerial Robotics IITK',
        title: 'Team Head',
        startDate: '04/2021',
        endDate: '05/2022',
        location: 'IIT Kanpur, UP',
        type: 'onsite',
        iconLink: './images/experiences/ariitk.png',
    },
    {
        name: 'Airbus India',
        title: 'Robotics Engineer',
        startDate: '05/2022',
        endDate: '07/2022',
        location: 'Bangalore, Karnataka',
        type: 'onsite',
        iconLink: './images/experiences/airbus.png',
    },
    {
        name: 'Wells Fargo',
        title: 'Program Associate',
        startDate: '07/2023',
        endDate: 'Ongoing',
        location: 'Bangalore, Karnataka',
        type: 'onsite',
        iconLink: './images/experiences/wells-fargo.png',
    },
]

export default Experiences